import TestStore from './test_store';
import GamificationStore from './gamificationStore';
export const isServer = typeof window === 'undefined';
import { enableStaticRendering } from 'mobx-react-lite';
if (isServer) {
  console.log('Enable static rendering', isServer);
  enableStaticRendering(isServer);
}

let clientSideStores: any;
let serverSideStore: any;

export function getStores(existing = false, initialData: any) {
  if (isServer && existing) {
    return serverSideStore;
  }

  if (isServer) {
    serverSideStore = {
      testStore: new TestStore({}),
      gamificationStore: new GamificationStore(),
    };
    console.log('New store?', serverSideStore);
    return serverSideStore;
  }
  if (!clientSideStores) {
    console.log('Initalizing stores with initial data', initialData);
    clientSideStores = {
      testStore: new TestStore(initialData),
      gamificationStore: new GamificationStore(),
    };
  }

  return clientSideStores;
}
